import { OptionCard } from './OptionCard'
import { OptionsGrid } from './styles/OptionCardStyles'
import { QuestionTitle } from './styles/SignUpFlowStyles'
import { USER_ROLE_OPTIONS } from '../../constants/surveyOptions'

interface SurveyStepRoleProps {
  value: string | null
  onChange: (value: string) => void
}

export function SurveyStepRole({ value, onChange }: SurveyStepRoleProps) {
  return (
    <div>
      <QuestionTitle>Who is this workspace for?</QuestionTitle>
      <OptionsGrid>
        {USER_ROLE_OPTIONS.map((option) => (
          <OptionCard
            key={option.value}
            label={option.label}
            isSelected={value === option.value}
            onClick={() => onChange(option.value)}
            isMultiSelect={false}
          />
        ))}
      </OptionsGrid>
    </div>
  )
}
